import React, { FC } from 'react';
import { FormControl, InputLabel, Select } from '@material-ui/core';
import data_criticity from '../../data/criticity';

interface Props {
  value?: number;
  error?: boolean;
  required?: boolean;
  helperText?: string;
  className?: any;
  size?: 'small' | 'medium';
  fullWidth?: boolean;
  onChange: (event: React.ChangeEvent<{ name?: string; value: unknown }>) => void;
}

const CriticitySelect: FC<Props> = React.forwardRef<any, Props>(
  ({ onChange, className, value, helperText, required, ...props }, ref) => {
    return (
      <FormControl
        ref={ref}
        className={className}
        variant='outlined'
        error={props.error}
        required={required}
        {...props}
      >
        <InputLabel>Criticité</InputLabel>
        <Select native label='Criticité *' value={value} style={{ background: 'white' }} onChange={onChange}>
          <option value='' />
          {Object.entries(data_criticity).map(([key, data]: [string, any]) => (
            <option key={key} value={key}>
              {data.fr}
            </option>
          ))}
        </Select>
      </FormControl>
    );
  }
);

export default CriticitySelect;
